import { Box, Text, VStack } from '@chakra-ui/react';

function Data({ userData }) {
  const list = [
    {
      id: 1,
      name: 'Total Bookings',
      value: userData.total_bookings || 0,  // Use userData value
      color: 'yellow',
    },
    {
      id: 2,
      name: 'Bookings Completed',
      value: userData.total_completed_bookings || 0,  // Use userData value
      color: 'green',
    },
    {
      id: 3,
      name: 'Booking Declined',
      value: userData.total_declined_bookings || 0,  // Use userData value
      color: 'cadet',
    },
  ];

  return (
    <VStack as="ul" spacing={0} listStyleType="none">
      {list.map((item) => (
        <Box
          key={item.id}
          as="li"
          w="full"
          py={3}
          px={5}
          d="flex"
          alignItems="center"
          justifyContent="space-between"
          borderBottomWidth={1}
          borderColor="brand.light"
        >
          <Text color="brand.dark">{item.name}</Text>
          <Text color={`brand.${item.color}`} fontWeight="bold">
            {item.value}
          </Text>
        </Box>
      ))}
    </VStack>
  );
}

export default Data;
